import clsx from 'clsx'
import { ReactNode } from 'react'

interface Props {
    legend?: ReactNode
    className?: string
}

const InputLegend = ({ legend, className }: Props) => {
    return (
        <div
            className={clsx(
                'font-extrabold text-typography-text-md leading-[18px] text-dark',
                'mt-0.5 mb-1',
                className,
            )}>
            {legend}
        </div>
    )
}

export default InputLegend
